export const formatAptNum = (address) => {
  return address.apt ? ', Apt.#' + address.apt : '';
}


// WEBPACK FOOTER //
// ./src/helpers/addressHelper.js